import {} from '@routable/types';
export const COMBOBOX_CLOSE_ACTION = 'combobox:window:event';
export const COMBOBOX_VALUE_SELECTED = 'combobox:window:value:change';
export const COMBOBOX_VALUE_CACHED = 'combobox:window:value:cached';
